import { supabase } from './supabase';

export async function uploadImage(file: File, path: string = ''): Promise<string> {
  try {
    const fileExt = file.name.split('.').pop();
    const randomSuffix = Math.random().toString(36).substring(2, 8);
    const fileName = `${Date.now()}_${randomSuffix}.${fileExt}`;
    const filePath = path ? `${path}/${fileName}` : fileName;

    // Upload to Supabase Storage
    const { data, error } = await supabase.storage
      .from('wageh')
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (error) {
      console.error('Error uploading image:', error);
      throw error;
    }

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('wageh')
      .getPublicUrl(filePath);

    console.log('Image uploaded successfully:', publicUrl);
    return publicUrl;
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }
}

export async function deleteImage(url: string): Promise<void> {
  try {
    // Extract file path from URL
    const urlParts = url.split('/');
    const fileName = urlParts[urlParts.length - 1];
    const filePath = fileName;

    // Delete from Supabase Storage
    const { error } = await supabase.storage
      .from('wageh')
      .remove([filePath]);

    if (error) {
      console.error('Error deleting image:', error);
      throw error;
    }

    console.log('Image deleted successfully:', url);
  } catch (error) {
    console.error('Delete error:', error);
    throw error;
  }
}
